import React from 'react';
import { DateTime, Numberbox, SectionPanel, Textarea, ValidationLevel } from 'ui';
import { MainGridContainer } from 'ui/common/main-grid-container/main-grid-container';
import { parseAsDateUTC, createUTCDate, dateToUTC, createFormatters } from 'app/infrastructure/data/date';
import { MetroLineSection } from 'app/components/metro-line/metro-line-section';
import { CompanyReportSectionType } from '../metroline/types';
import { CompanyReportFormIds } from '../constants';
import { CompanyReportSection } from '../types';
import { isDefinedIncludingZero } from 'app/infrastructure/data/number';
import { maxCompanyReportId } from 'app/area/company-reports-administration/constants';

export const CompanyReportDetails: React.FC<CompanyReportSection> = ({
  companyReportItem, updateItem, locale, validation, translation, section, getRef, shouldRenderSection
}) => {

  const hasCompanyReportId = isDefinedIncludingZero(companyReportItem?.id);

  const onSequenceChange = (value: number) => {
    updateItem({ sequence: value });
  };

  const onDisabledChange = (value: Date) => {
    updateItem({ disabled: value });
  };

  const onTemplateTextChange = (value: string) => {
    updateItem({ [CompanyReportFormIds.template]: { value: companyReportItem?.template?.value, description: value } });
  };

  const onDefaultTemplateTextChange = (value: string) => {
    updateItem({ [CompanyReportFormIds.defaultTemplate]: { value: companyReportItem?.defaultTemplate?.value, description: value } });
  };

  return <MetroLineSection<CompanyReportSectionType>
    section={section}
    sectionType={CompanyReportSectionType.Details}
    getRef={getRef}
    shouldRenderSection={shouldRenderSection}>
    <div ref={getRef(CompanyReportSectionType.Details)}>
      <SectionPanel
        className="admin-paper-top-panel"
        componentId={CompanyReportSectionType.Details}
        validation={undefined}
        info={{ text: translation.details }}
        label={{ visible: true, text: translation.details }} />
      <MainGridContainer>
        <div className="row">
          <div className="col-lg-6 col-sm-12">
            <Numberbox
              componentId={CompanyReportFormIds.sequenceId}
              label={translation ? { text: translation.sequence } : undefined}
              value={companyReportItem?.sequence}
              onChange={onSequenceChange}
              useThousand=" "
              maxValue={999999999}
              locale={locale}
              validation={validation.sequence}
              textInvalidRangeError={translation.must_be_within_range} />
          </div>
          <div className="col-lg-6 col-sm-12">
            <DateTime
              componentId={CompanyReportFormIds.disabledId}
              className="dateTime"
              value={companyReportItem?.disabled}
              label={translation ? { text: translation.disabled } : undefined}
              useTime={false}
              parseDate={parseAsDateUTC}
              createDate={createUTCDate}
              cloneDate={dateToUTC}
              {...createFormatters(locale)}
              locale={locale}
              onChange={onDisabledChange}
              captionWrapper={'form'}
              validation={validation.disabled} />
          </div>
        </div>
        {hasCompanyReportId && <div className="row">
          <div className="col-lg-6 col-sm-12">
            <Textarea
              componentId={CompanyReportFormIds.template}
              value={companyReportItem?.template?.value ? companyReportItem?.template?.description : ''}
              info={{ text: translation.template_disclaimer, visible: true }}
              label={{ text: translation.template_name }}
              validation={companyReportItem?.template?.value
                ? validation?.template
                : {
                  level: ValidationLevel.warning, messages: [{
                    level: ValidationLevel.warning,
                    message: translation.template_warning
                  }]
                }}
              readOnly={true}
              onChange={onTemplateTextChange} />
          </div>
          {companyReportItem?.id < maxCompanyReportId
            && <div className="col-lg-6 col-sm-12">
              <Textarea
                componentId={CompanyReportFormIds.defaultTemplate}
                value={companyReportItem?.defaultTemplate?.value ? companyReportItem?.defaultTemplate?.description : ''}
                label={{ text: translation.template_default_name }}
                validation={validation?.defaultTemplate}
                readOnly={true}
                onChange={onDefaultTemplateTextChange} />
            </div>}
        </div>}
      </MainGridContainer>
    </div>
  </MetroLineSection>;
};
